import React from 'react'
import { Root } from './src/root'

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <Root>{element}</Root>
}
